<template>
  <table
    class="table-hover reports-table payments-table table"
    :class="{ 'skip-hover': groupedBy == 'paid' }"
  >
    <tbody class="thead">
      <tr>
        <th
          v-if="walker.sub_show"
          class="sticky-cell"
        >
          {{ walker.sub_label }}
        </th>
        <th v-if="walker.third_show">
          {{ walker.third_label }}
        </th>
        <th
          v-if="tableShowNotes"
          class="note-cell"
        >
          Notes
        </th>
        <th class="text-right">Total Hours</th>
        <th class="text-right">Hourly pay</th>
        <th class="text-right">Fixed pay</th>
        <th class="text-right">PTO & Holidays</th>
        <th class="text-right">Additions</th>
        <th class="text-right">Deductions</th>
        <th class="text-right">Bonus</th>
        <th class="text-right">Total Amount</th>
      </tr>
    </tbody>
    <ReportVirtualTableBody
      v-slot="{ row: section }"
      :rows="tableData.sections"
      :item-size="49"
    >
      <tr
        v-if="tableIsTeam && walker.base_column_count"
        class="tbody grouping-header"
      >
        <th
          v-if="walker.sub_show"
          class="sticky-cell"
        >
          <template v-if="walker.main_type == 'date'">
            {{ formatDateLabel(section.main) }}
          </template>
          <template v-else-if="walker.main_type == 'user'">
            <MemberPaymentAccountPopup
              :organization-id="organization.id"
              :user-id="section.main_id"
              :image-url="section.rows[0].record.avatar_url"
              :name="section.main"
              :show-member-profile="managePaymentInfo"
              tab="pay / bill"
              title=""
            />
          </template>
          <template v-else>
            {{ section.main }}
          </template>
        </th>
        <th class="text-right">
          <strong
            v-if="groupedBy === 'paid'"
            v-tooltip
            class="hover-underline total"
            title="View payment"
          >
            <a
              :href="`/team_payments/past?date=${section.main}&date_end=${section.main}`"
              target="_blank"
            >
              {{ section.total.amount | currency(organization.currency) }}
            </a>
          </strong>
          <strong
            v-else
            class="total"
          >
            {{ section.total.amount | currency(organization.currency) }}
          </strong>
        </th>
      </tr>

      <ReportVirtualTableBody
        v-slot="{ row }"
        :rows="section.rows"
        nested
        main-column-without-corner-padding
        :skip-table-hover="groupedBy == 'paid'"
      >
        <tr>
          <td
            v-if="walker.sub_show"
            class="sticky-cell"
          >
            {{ teamPaymentSourceName(row.record.sub) }}
          </td>

          <td v-if="walker.third_show">
            <template v-if="row.third_show_data">
              <template v-if="walker.third_type == 'date'">
                {{ formatDateLabel(row.record.third) }}
              </template>
              <template v-else-if="walker.third_type == 'user'">
                <MemberPaymentAccountPopup
                  :organization-id="organization.id"
                  :user-id="row.record.third_id"
                  :image-url="row.record.avatar_url"
                  :name="row.record.third"
                  :show-member-profile="managePaymentInfo"
                  tab="pay / bill"
                  title=""
                />
              </template>
              <template v-else>
                {{ row.record.third }}
              </template>
            </template>
          </td>

          <td
            v-if="tableShowNotes"
            v-popover:left
            class="long-text-cell"
            :data-content="row.record.note"
          >
            {{ row.record.note }}
          </td>
          <td class="text-right">{{ formatDuration(row.record.total_hours, { blank: '-' }) }}</td>
          <td class="text-right">{{ parseAmount(row.record.hourly_rate_amount) | currency(organization.currency) }}</td>
          <td class="text-right">{{ parseAmount(row.record.fixed_rate_amount) | currency(organization.currency) }}</td>
          <td class="text-right">{{ parseAmount(row.record.pto_holidays_amount) | currency(organization.currency) }}</td>
          <td class="text-right">{{ parseAmount(row.record.additions_amount) | currency(organization.currency) }}</td>
          <td class="text-right">{{ parseAmount(row.record.deductions_amount) | currency(organization.currency) }}</td>
          <td class="text-right">{{ parseAmount(row.record.bonus_amount) | currency(organization.currency) }}</td>
          <td class="text-right">{{ row.record.amount | currency(organization.currency) }}</td>
        </tr>
      </ReportVirtualTableBody>


    </ReportVirtualTableBody>
  </table>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import MemberPaymentAccountPopup from '~/components/financials/MemberPaymentAccountPopup.vue';
import { formatDuration } from '~/utils/time_utils';

export default {
  name: 'PaymentsReportTable',
  components: {
    MemberPaymentAccountPopup,
  },
  props: {
    tableData: Object,
    groupedBy: String,
  },
  computed: {
    ...mapGetters(['tableIsTeam', 'tableShowNotes', 'walker', 'managePaymentInfo']),
    ...mapState({
      organization: 'organization',
    }),
  },
  methods: {
    formatDuration,
    formatDateLabel(value) {
      if (value === 'summed_date') {
        return (
          TimeUtils.format_date(TimeUtils.parse_internal_date(this.$store.state.report_query.date)) +
          ' - ' +
          TimeUtils.format_date(TimeUtils.parse_internal_date(this.$store.state.report_query.date_end))
        );
      }

      return TimeUtils.format_date(TimeUtils.parse_internal_date(value));
    },
    teamPaymentSourceName: function (source) {
      const source_name_map = this.$store.state.team_payment_source_name_map;

      return source_name_map[source] || '';
    },
    parseAmount(amount) {
      return parseFloat(amount) || 0;
    },
  },
};
</script>
